export const scopeStringId = "company"